"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNeedCompanyIds = void 0;
const getNeedCompanyIds = (need) => {
    if (need.type === 'FIXED_DATE')
        return need.companyId ? [need.companyId] : [];
    return need.companies ?? [];
};
exports.getNeedCompanyIds = getNeedCompanyIds;
